import { Component } from '@angular/core';

/**
 * Author: Sridhar Swaminathan
 * 
 * Date Created: November 14th 2017
 * 
 * Description: Component class for Data Protection Act (obsolete)
 **/
@Component({
    templateUrl:  'dataprotection.component.html',
    styles: [`
     a {
            color: #337ab7;
            text-decoration: none;
      }
      a:hover, a:focus {
        color: #1ebebc;
        text-decoration: underline;
      }
    `]
})

export class DataprotectionComponent{

}



// WEBPACK FOOTER //
// ./src/app/staticpage/dataprotection.component.ts